import { forwardRef, useCallback, useMemo, useState } from 'react';
import { Input, InputProps } from 'shared/components/Input/Input';
import { CrossedEyeIcon, EyeIcon } from 'shared/icons';
import { mergeClasses } from 'shared/utils/mergeClasses';
import { IconButton } from './IconButton/IconButton';

export const PasswordInput = forwardRef<HTMLInputElement, InputProps>(
  ({ onChange, label, ...rest }, ref) => {
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);

    const togglePasswordVisibility = useCallback(() => {
      setIsPasswordVisible((prev) => !prev);
    }, []);

    const endAdornment = useMemo(
      () => (
        <IconButton
          onClick={togglePasswordVisibility}
          name="showPasswordButton"
          variant="black"
          className={mergeClasses('pl-4', isPasswordVisible ? 'translate-x-px translate-y-px' : '')}
          icon={isPasswordVisible ? CrossedEyeIcon : EyeIcon}
        />
      ),
      [isPasswordVisible, togglePasswordVisibility],
    );

    return (
      <Input
        {...rest}
        ref={ref}
        label={label}
        type={isPasswordVisible ? 'text' : 'password'}
        endAdornment={endAdornment}
        onChange={onChange}
      />
    );
  },
);
